import { callable } from './callable'

export interface ApproveJoinRequestInput {
  workspaceId: string
  requestId: string
  role?: string
}

export interface ApproveJoinRequestResult {
  ok: true
  workspaceId: string
  requestId: string
  memberId: string
  role: string
}

export interface AssignMemberCreditsInput {
  workspaceId: string
  memberId: string
  amount: number
}

export interface AssignMemberCreditsResult {
  ok: true
  workspaceId: string
  memberId: string
  amount: number
  workspaceCredits: number
  memberCredits: number
}

export const approveJoinRequestCallable = async (
  input: ApproveJoinRequestInput,
): Promise<ApproveJoinRequestResult> => {
  return callable<ApproveJoinRequestInput, ApproveJoinRequestResult>('approveJoinRequest', input)
}

export const assignMemberCreditsCallable = async (
  input: AssignMemberCreditsInput,
): Promise<AssignMemberCreditsResult> => {
  return callable<AssignMemberCreditsInput, AssignMemberCreditsResult>('assignMemberCredits', input)
}
